import React from 'react';

import { Modal } from '../../../../../../../../components';

import {
  OkeyBtn,
} from './Styles';
import { errorBlack } from '../../../../../../../../assets/Svg';
import Image from '../../../../../../../../components/Image';

const NotFoundNoticeModal: React.FC<Props> = ({
  onClose,
  isEnglish,
}) => {
  return (
    <Modal
      style={{ width: '275px', minWidth: 'unset', padding: 'unset', textAlign: 'center', paddingBottom: '26px', borderRadius: '22px' }}
    >
      {/* 图标 */}
      <div>
        <Image srcImg={errorBlack} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </div>
      {
        isEnglish ? (
          <div style={{ marginTop: '20px', fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B' }}>
            Sorry...
          </div>
        ) : (
          <div style={{ marginTop: '20px', fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B' }}>
            抱歉...
          </div>
        )
      }
      {
        isEnglish ? (
          <div style={{ margin: '20px auto 0 auto', fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '24px', textAlign: 'center', width: '236px' }}>
            The unit number you entered<br />
            does not match our records.<br />
            Please try again.
          </div>
        ) : (
          <div style={{ margin: '20px auto 0 auto', fontSize: '16px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '24px', textAlign: 'center', width: '236px' }}>
            您输入的门牌号没有匹配的<br />订单。请确认后重试。
          </div>
        )
      }
      {/* Okay按钮 */}
      <OkeyBtn onClick={() => onClose()}>
        {
          isEnglish ? (
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '21px' }}>
              Okay
            </div>
          ) : (
            <div style={{ fontSize: '16px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px' }}>
              好的
            </div>
          )
        }
      </OkeyBtn>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
}

export default NotFoundNoticeModal;
